module.exports = __webpack_public_path__ + "static/media/2.5ad170eb.jpg";